export function formatCurrency(value: number, currency = 'EUR'): string {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(value);
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  return new Intl.DateTimeFormat('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(value));
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  return new Intl.DateTimeFormat('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value));
}

export function defaultDateRange(): { startDate: string; endDate: string } {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 30);
  return {
    startDate: start.toISOString().slice(0, 10),
    endDate: end.toISOString().slice(0, 10),
  };
}

export function licenseStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    activa: 'Activa',
    pendiente_activacion: 'Pendiente de activación',
    cancelada: 'Cancelada',
    caducada: 'Caducada',
    desactivada: 'Desactivada',
  };
  return labels[status] ?? status;
}

export function licenseStatusTone(status: string): 'success' | 'warning' | 'danger' | 'neutral' {
  if (status === 'activa') return 'success';
  if (status === 'pendiente_activacion') return 'warning';
  if (status === 'cancelada') return 'neutral';
  return 'danger';
}
